import React from 'react';
import { Link } from 'react-router-dom';
import { brands } from '../mock';

const BrandTile = ({ b }) => (
  <div className="flex items-center justify-center h-16 md:h-20 px-6 py-4 bg-white rounded-2xl border border-[#1F0068]/5 shrink-0 min-w-[140px]">
    <img
      src={b.src}
      alt={b.name}
      loading="lazy"
      className="max-h-8 md:max-h-10 max-w-[100px] md:max-w-[120px] object-contain grayscale hover:grayscale-0 transition-all"
      onError={(e) => { e.currentTarget.style.display = 'none'; e.currentTarget.parentElement.innerHTML = `<span class='font-bold text-[#1F0068]/60 text-lg'>${b.name}</span>`; }}
    />
  </div>
);

const BrandStrip = () => {
  const doubled = [...brands, ...brands];
  return (
    <section id="brands" className="py-16 md:py-24 bg-white scroll-mt-24">
      <div className="max-w-7xl mx-auto px-5">
        <div className="max-w-2xl mb-10">
          <div className="text-xs uppercase tracking-[0.22em] font-bold text-[#FF5C39] mb-3">Who we are</div>
          <h2 className="text-4xl md:text-5xl font-bold text-[#1F0068] tracking-tight leading-tight">
            Know these brands? Then you know us.
          </h2>
          <p className="mt-4 text-[#1F0068]/70 text-lg">
            The brands you know and love trust Domestic Home Services to protect their products, from home appliances to boilers and TVs. So while you may not see our logo in kitchens or living rooms, we’re right there — making things run smoothly for millions of UK homes.
          </p>
        </div>

        <div className="relative overflow-hidden py-4 border-y border-[#1F0068]/10">
          <div className="marquee-track flex gap-4 whitespace-nowrap w-max">
            {doubled.map((b, i) => <BrandTile key={i} b={b} />)}
          </div>
        </div>

        <div className="mt-6 text-center">
          <Link to="/appliance-cover" className="text-sm font-semibold text-[#FF5C39] hover:underline">See all 100+ brands we cover →</Link>
        </div>
      </div>
    </section>
  );
};

export default BrandStrip;
